import { GridContent } from './GridContent';

// TODO: in v9, move styled() from GridContent.jsx to here
export var StyledGridContent = GridContent;